var _defs, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgThunder01 = function SvgThunder01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient);\n      }"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 10.51,
    y1: 166.12,
    x2: 173.14,
    y2: 45.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 26.83,
    y1: 188.08,
    x2: 189.47,
    y2: 67.24,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 42.94,
    y1: 209.77,
    x2: 205.58,
    y2: 88.92,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 59.37,
    y1: 231.88,
    x2: 222.01,
    y2: 111.03,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -18.26,
    y1: 127.4,
    x2: 144.37,
    y2: 6.55,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -22.3,
    y1: 121.96,
    x2: 140.33,
    y2: 1.12,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M161.23,48.52c-2.9,0-5.86.39-8.99,1.19-7.65-16.66-23.99-27.26-42.45-27.26-20.44,0-38.36,13.08-44.59,32.55-.57,1.76.41,3.65,2.17,4.21,1.77.57,3.65-.41,4.21-2.17,5.34-16.69,20.7-27.9,38.22-27.9,15.57,0,29.38,8.82,36.06,22.73-4.6,2.1-7.78,5.2-9.73,7.68-1.14,1.45-.9,3.56.56,4.7.61.48,1.34.72,2.07.72.99,0,1.97-.44,2.63-1.27,1.81-2.3,4.99-5.33,9.85-6.72.02,0,.09-.03.11-.03,3.57-1.16,6.8-1.73,9.88-1.73,17.69,0,32.08,14.39,32.08,32.08s-14.39,32.08-32.08,32.08H58.91c-13.32,0-24.16-10.84-24.16-24.16s10.84-24.16,24.16-24.16c1.97,0,4.02.32,6.47,1.01,3.2.97,6.18,2.7,8.37,4.89.65.65,1.51.97,2.36.97s1.72-.33,2.37-.99c1.3-1.31,1.3-3.43-.01-4.73-2.97-2.95-6.94-5.28-11.19-6.56-.01,0-.02,0-.03,0,0,0-.02-.01-.03-.01-3.07-.86-5.71-1.26-8.31-1.26-17.02,0-30.86,13.84-30.86,30.86s13.84,30.85,30.86,30.85h102.32c21.38,0,38.77-17.39,38.77-38.77,0-21.38-17.39-38.77-38.77-38.77"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M67.93,137.78c-.12,0-.23,0-.35,0-1.08.09-2.06.69-2.6,1.63l-9.86,16.45c-1.34,2.2.24,5.01,2.82,5.01h13.93l-6.88,11.47c-2.64,3.85,3.49,7.52,5.64,3.37l9.89-16.45c1.3-2.19-.27-4.97-2.82-4.98h-13.95l6.88-11.47c1.35-2.15-.15-4.96-2.69-5.04Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M114.19,137.08c-.12,0-.25,0-.37,0-1.08.09-2.05.69-2.6,1.63l-9.87,16.45c-1.34,2.2.25,5.02,2.82,5.01h13.92l-6.87,11.47c-2.48,3.83,3.47,7.38,5.66,3.37l9.87-16.45c1.31-2.19-.27-4.97-2.82-4.98h-13.94l6.9-11.47c1.35-2.15-.15-4.96-2.69-5.04Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M160.44,137.08c-.12,0-.25,0-.37,0-1.08.09-2.06.69-2.6,1.63l-9.86,16.45c-1.34,2.2.24,5.01,2.82,5.01h13.93l-6.88,11.47c-2.25,3.78,3.41,7.15,5.66,3.37l9.86-16.45c1.3-2.19-.27-4.97-2.82-4.98h-13.95l6.91-11.47c1.35-2.15-.15-4.96-2.69-5.04Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M19.67,95.6c0-6.38,2.49-12.38,7-16.89.57-.57.89-1.33.89-2.14s-.32-1.57-.89-2.15c-1.18-1.18-3.11-1.18-4.29,0h0c-5.66,5.66-8.77,13.18-8.77,21.18s3.12,15.52,8.77,21.18c.57.57,1.33.89,2.14.89s1.57-.32,2.14-.89c.57-.57.89-1.33.89-2.14s-.32-1.57-.89-2.14c-4.51-4.51-7-10.51-7-16.89"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M6.07,95.6c0-8.44,3.29-16.37,9.25-22.33,1.18-1.18,1.18-3.11,0-4.29-1.18-1.18-3.1-1.18-4.29,0C3.92,76.09,0,85.55,0,95.6s3.92,19.51,11.03,26.62c.59.59,1.37.89,2.14.89s1.55-.3,2.14-.89c1.18-1.18,1.18-3.11,0-4.29-5.96-5.96-9.25-13.9-9.25-22.33"
  })));
};
export default SvgThunder01;